export default "__VITE_PUBLIC_ASSET__78ed4cfa__"